module.exports = __webpack_public_path__ + "img/halloween_happy.2d297092.svg";